import * as THREE from 'three'; // 👈 Añade esto al principio de todo

export const marcadoresRutas_fuera_agua = [];

export function vincularMarcadorAlSites(reefMesh, escena) {
    reefMesh.updateMatrixWorld(true);

    const box = new THREE.Box3().setFromObject(reefMesh);
    const centro = new THREE.Vector3();
    box.getCenter(centro);

    const nombreLimpio = reefMesh.name
        .replace("BEACH_", "")
        .replace(/_/g, " ");

    // Creamos el letrero dinámico
    const labelSprite = crearLetreroTexto_fuera_agua(nombreLimpio);

    // Posicionamos el letrero en el centro del Reef
    labelSprite.position.copy(centro);
    
    // Ajustamos la altura de flotación (Y) igual que en los Reefs
    labelSprite.position.y += 0.0025; 

    labelSprite.visible = true;

    // Agregamos solo el letrero a la escena
    escena.add(labelSprite);

    // Guardamos la referencia
    marcadoresRutas_fuera_agua.push({
        letrero: labelSprite,
        nombre_reef: nombreLimpio
    });

    console.log("[SITE CENTRO]", nombreLimpio, centro);
}

export function crearLetreroTexto_fuera_agua(texto) {
    const textoLimpio = texto.replace(/-/g, " ");

    // 1. CREACIÓN DE UN CANVAS TEMPORAL PARA MEDIR EL TEXTO
    const canvasMedición = document.createElement("canvas");
    const ctxMedición = canvasMedición.getContext("2d");
    ctxMedición.font = "bold 18px sans-serif";
    
    // Medimos cuántos píxeles ocupa el texto real
    const metrics = ctxMedición.measureText(textoLimpio);
    
    // Mismo padding horizontal que el letrero con icono para mantener consistencia visual
    const paddingX = 24; 
    const canvasWidth = Math.max(64, metrics.width + paddingX); 
    const canvasHeight = 32; // Misma altura compacta de 32

    // 2. CREACIÓN DEL CANVAS REAL CON EL ANCHO EXACTO Y DINÁMICO
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    // 3. DIBUJAR EL FONDO REDONDEADO DINÁMICO
    // Fondo oscuro con matiz cálido/naranja
    ctx.fillStyle = "rgba(25, 15, 5, 0.85)"; 
    // Borde naranja claro constante
    ctx.strokeStyle = "#ffb366"; 
    ctx.lineWidth = 1.5; 

    const rectX = 1;
    const rectY = 1;
    const rectW = canvasWidth - 2;
    const rectH = canvasHeight - 2;
    const radioCórner = 6; 

    if (ctx.roundRect) {
        ctx.beginPath();
        ctx.roundRect(rectX, rectY, rectW, rectH, radioCórner);
        ctx.fill();
        ctx.stroke();
    } else {
        ctx.fillRect(rectX, rectY, rectW, rectH);
        ctx.strokeRect(rectX, rectY, rectW, rectH);
    }

    // 4. DIBUJAR EL TEXTO PERFECTAMENTE CENTRADO (Ya que no hay icono aquí)
    ctx.font = "bold 18px sans-serif"; 
    ctx.fillStyle = "#ffffff"; 
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(textoLimpio, canvasWidth / 2, canvasHeight / 2);

    // 5. MAPEAR TEXTURA Y APLICAR LA MISMA ESCALA QUE EL REEF
    const texture = new THREE.CanvasTexture(canvas);
    const spriteMaterial = new THREE.SpriteMaterial({
        map: texture,
        transparent: true,
        depthTest: false
    });

    const sprite = new THREE.Sprite(spriteMaterial);

    // --- CORRECCIÓN: Ahora usa 0.0035 para igualar el tamaño exacto del letrero de buceo ---
    const escalaBaseY = 0.0035; 
    const relacionAspecto = canvasWidth / canvasHeight;
    const escalaBaseX = escalaBaseY * relacionAspecto;

    sprite.scale.set(escalaBaseX, escalaBaseY, 1);

    return sprite;
}